import { render, staticRenderFns } from "./item-suppliers.vue?vue&type=template&id=2f44717e&scoped=true&"
import script from "./item-suppliers.vue?vue&type=script&lang=js&"
export * from "./item-suppliers.vue?vue&type=script&lang=js&"
import style0 from "./item-suppliers.vue?vue&type=style&index=0&id=2f44717e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f44717e",
  null
  
)

export default component.exports